<template>
    <div class="mobile-catalog-vue">
        <div
            class="catalog-header"
            v-show="showCatalog"
        >
            <div class="left-panel">
                <a
                    v-if="isSearching"
                    href="javascript:void(0)"
                    class="search-results-header"
                    @click.prevent="goBack"
                >
                    <i class="icon icon-chevronleft"></i>
                    <div>
                        <div class="title">{{ categoryTitle }}</div>
                        <div class="subtitle">{{ foundText }}</div>
                    </div>
                </a>
                <!-- #111877: opens the in-page picker; the href stays as a no-JS fallback -->
                <a
                    v-else
                    :href="categoryUrl + (checkIsReturnMode() ? '?isReturnMode=true' : '?isReturnMode=false')"
                    @click.prevent="$emit('open_category_picker')"
                >
                    <i class="icon icon-chevronleft"></i>
                    <div class="title theme-primary-color">{{ categoryTitle }}</div>
                </a>
            </div>

            <!-- Filter product for future development -->
            <!-- <div class="right-panel">
                    <div class="sorting">
                        <span class="theme-primary-color">Sort By</span>
                        <select name="" id="" class="form-control">
                            <option value="">Name</option>
                            <option value="">SKU</option>
                            <option value="">Product Quantity (Low to High)</option>
                            <option value="">Product Quantity (High to Low)</option>
                        </select>
                    </div>
                    <div class="filter">
                        <i class="icon-filteralt"></i>
                    </div>
                </div> -->
        </div>
        <div
            class="mobile-catalog-list"
            v-show="showCatalog"
        >
            <bo-related-categories v-if="isSearching"></bo-related-categories>
            <div class="product-listing">
                <div
                    class="product-item"
                    v-for="(product, index) in productsData"
                    :key="product.index"
                    v-if="
                        product.catalog_visibility &&
                        (categoryIdNum > 0 ||
                            categoryIdNum === null ||
                            isFrequentlyPurchased ||
                            (isFavourites && product.favorited))
                    "
                >
                    <a
                        :href="product.product_details_url"
                        class="product-info"
                    >
                        <div class="image">
                            <img
                                :src="product.images"
                                alt="image"
                                @error="showPlaceholderImage"
                            />
                            <i
                                v-if="enabledFavoriteProduct"
                                :id="'favorite-icon-' + product.id"
                                :class="[
                                    'favorite-icon',
                                    product.favorited ? 'icon-favoritefilled' : 'icon-favorite',
                                    product.favorited ? 'is-favorited' : '',
                                ]"
                                @click.stop.prevent="
                                    product.favorited = !product.favorited;
                                    favoriteProduct(product, index, 'favorite-icon-' + product.id);
                                "
                            >
                            </i>
                        </div>
                        <div class="product-detail">
                            <div
                                class="volume-price-tag"
                                v-if="product.has_volume_pricing && canReadPrices"
                            >
                                <span>{{ catalogTranslations.volume_pricing ?? "Volume Pricing" }}</span>
                            </div>
                            <div class="badges">
                                <span
                                    v-if="product.type == 'bundle'"
                                    class="bundle-badge"
                                    >{{ catalogTranslations.bundle ?? "Bundle" }}</span
                                >
                                <span class="sku">{{ product.sku }}</span>
                                <span
                                    class="backorder"
                                    v-show="false"
                                >
                                    {{ catalogTranslations.allow_backorder ?? "Allow Backorder" }}
                                </span>
                            </div>
                            <div class="name theme-primary-color">
                                {{ product.name }}
                            </div>
                            <div
                                v-if="cardSnippets[product.id]"
                                class="search-description"
                            >
                                “{{ cardSnippets[product.id] }}”
                            </div>
                            <div class="point">
                                <bo-product-details
                                    class="item-weight"
                                    :parts="productDetails(product)"
                                ></bo-product-details>
                            </div>
                            <bo-price-display
                                v-if="canReadPrices"
                                size="medium"
                                v-bind="getCatalogPriceDisplay(product)"
                            ></bo-price-display>
                            <bo-bundle-deal-link
                                v-if="product.has_related_bundles"
                                :label="catalogTranslations.available_in_bundle_deal ?? 'Available in a bundle deal'"
                                @click="$emit('open_related_bundles', product)"
                            ></bo-bundle-deal-link>
                        </div>
                    </a>

                    <button
                        class="catalog-quick-add-button"
                        @click.stop.prevent="quickAddProduct(product)"
                    >
                        <span class="add-plus">+</span>
                    </button>
                    <div
                        v-if="product.is_matrix_product"
                        class="variation-selection"
                        @click="activateProductMatrixPopup($event, product)"
                    >
                        {{
                            generalTranslations.select_object.replace(":object", catalogTranslations.variation) ??
                            "Select Variation"
                        }}
                        <i class="icon-chevronright"></i>
                    </div>
                </div>
            </div>
        </div>

        <bo-popup-modal
            class="catalog-popup"
            :no-title="true"
            :active="activeProductMatrixPopup"
            :keep-alive="true"
            :show-modal-footer="false"
            @deactivate="activeProductMatrixPopup = false"
            @trigger="productMatrixAddToCart = true"
        >
            <template #body-content>
                <bo-product-matrix
                    :add-to-cart-prop="productMatrixAddToCart"
                    :product="matrixProduct"
                    :is-popup="true"
                    @deactivate="activeProductMatrixPopup = false"
                    @added_to_cart_or_error="
                        productMatrixAddToCart = false;
                        activeProductMatrixPopup = false;
                    "
                >
                </bo-product-matrix>
            </template>
        </bo-popup-modal>

        <!-- pagination starts-->

        <div
            v-if="
                (pagination && (categoryIdNum > 0 || categoryIdNum === null)) ||
                (isFrequentlyPurchased && totalAmount > 0) ||
                (totalAmount > 0 && isFavourites)
            "
            class="bo-pagination-footer"
        >
            <div class="pagination">
                <div class="page-item">
                    <span class="current-page">
                        {{ pagination.current_page }}
                    </span>
                    <span class="m-auto">/</span>
                    <span class="m-auto">
                        {{ pagination.last_page }}
                    </span>
                </div>
                <div class="page-navigation">
                    <span
                        v-for="(link, index) in pagination.links"
                        :key="index"
                        class="page-item"
                        v-if="link.label == 'pagination.previous' || link.label == 'pagination.next'"
                    >
                        <a
                            v-if="link.label == 'pagination.previous'"
                            :key="`${link.label}-prev`"
                            @click="link.url ? getPageNumber(link.url) : undefined"
                        >
                            <div class="page-btn">
                                <i class="icon-chevronleft"></i>
                            </div>
                        </a>

                        <a
                            v-else-if="link.label == 'pagination.next'"
                            :key="`${link.label}-next`"
                            @click="link.url ? getPageNumber(link.url) : undefined"
                        >
                            <div class="page-btn">
                                <i class="icon-chevronright"></i>
                            </div>
                        </a>
                    </span>
                </div>
            </div>
        </div>
        <div
            class="bo-empty-wrapper"
            :class="{ 'empty-wrapper-compact': isFrequentlyPurchased || isFavourites }"
            v-else-if="productsLoaded"
        >
            <div class="image">
                <bo-svg
                    :svg-content="
                        enabledFavoriteProduct || isFrequentlyPurchased
                            ? '/assets/graphics/img_empty.svg'
                            : '/assets/graphics/img-search.svg'
                    "
                    :primary-color="primaryColor"
                ></bo-svg>
            </div>
            <div
                v-if="isFrequentlyPurchased"
                class="title"
            >
                {{ catalogTranslations.no_frequently_purchased ?? "No frequently purchased items yet" }}
            </div>
            <div
                v-if="isFrequentlyPurchased"
                class="description"
            >
                {{
                    catalogTranslations.no_frequently_purchased_description ??
                    "Products you often order will appear here for quick reordering."
                }}
            </div>
            <div
                v-if="enabledFavoriteProduct && isFavourites"
                class="title"
            >
                {{ catalogTranslations.no_favorite ?? "No favourites yet" }}
            </div>
            <div
                v-if="enabledFavoriteProduct && isFavourites"
                class="description"
            >
                {{
                    catalogTranslations.no_favorite_description ??
                    "To add an item, click the heart icon on any product."
                }}
            </div>
        </div>

        <!-- pagination ends -->
    </div>
</template>

<script>
import Vue from "vue";
import httpMixin from "@/v2/mixins/http.js";
import productMixin from "@/v2/mixins/products.js";
import BoPoint from "js/frontend/components/bo-point.vue";
import BoMobileDropdown from "js/frontend/components/bo-mobile-catalog-dropdown.vue";
import * as utils from "@/v2/utils/utilities.js";
import { buildCatalogPriceDisplay } from "js/frontend/utils/catalog-price-display.js";
import { findCategoryName } from "js/frontend/utils/category-tree.js";
import { searchWords, descriptionSnippet } from "js/frontend/utils/search-text.js";
import { productDetailParts } from "js/frontend/utils/product-details.js";
import { showPlaceholderImage } from "js/frontend/utils/product-image.js";

Vue.component("bo-point", BoPoint);
Vue.component("bo-line-discount", require("js/frontend/components/bo-line-discount.vue").default);
Vue.component("bo-price-display", require("js/frontend/components/bo-price-display.vue").default);
Vue.component("bo-bundle-deal-link", require("js/frontend/components/bo-bundle-deal-link.vue").default);
Vue.component("bo-mobile-catalog-dropdown", BoMobileDropdown);
Vue.component("bo-related-categories", require("js/frontend/components/bo-related-categories.vue").default);
Vue.component("bo-product-details", require("js/frontend/components/bo-product-details.vue").default);
Vue.component("bo-popup-modal", require("@/v2/components/bo-popup-modal.vue").default);
Vue.component("bo-product-matrix-mobile", require("@/v2/components/product/bo-product-matrix-mobile.vue").default);
Vue.component("bo-product-matrix", require("@/v2/components/product/bo-product-matrix.vue").default);

export default {
    components: { BoPoint },
    mixins: [httpMixin, productMixin],
    props: {
        products: {
            type: Object,
            default: () => {},
        },
        title: {
            type: String,
            default: "",
        },
        categories: {
            type: Array,
            default: "",
        },
        catalogUrl: {
            type: String,
        },
        categoryid: {
            type: Number,
            default: null,
        },
        pointConfig: {
            type: [Object, Boolean],
            default: null,
        },
        isReturnMode: {
            type: Boolean,
            default: false,
        },
        taxIncluded: {
            type: Boolean,
            default: false,
        },
        displayPricesDuringCartAndCheckoutIncludingTax: {
            type: Boolean,
            default: false,
        },
        taxExempted: {
            type: Boolean,
            default: false,
        },
        // Price gate — see can_read_prices(). Defaults open so an un-passed prop is a no-op.
        canReadPrices: {
            type: Boolean,
            default: true,
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        weightUnit: {
            type: String,
            default: "",
        },
        isSearching: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            primaryColor: window.bo_primary_color || '#594c45',
            returnPopup: null,
            currentUrl: null,
            showCatalog: true,
            categoryUrl: window.bo.categoryUrl,
            pageNumber: "",
            activeProductMatrixPopup: false,
            hideLineItemTax: window.bo?.hideLineItemTax ?? false,
            productMatrixAddToCart: false,
            matrixProduct: null,
            generalTranslations: window.bo?.generalTranslations ?? {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
            currencySymbol: window.bo?.currencySymbol ?? {},
            enabledFavoriteProduct: window.bo?.enabledFavoriteProduct ?? false,
            changedIndex: 0,
        };
    },
    computed: {
        categoryIdNum() {
            return this.currentCategoryId === null || this.currentCategoryId === undefined
                ? null
                : Number(this.currentCategoryId);
        },
        isFavourites() {
            return this.categoryIdNum === -1;
        },
        isFrequentlyPurchased() {
            return this.categoryIdNum === -2;
        },
        // The page boots with an empty array; the API paginator carries a numeric total.
        productsLoaded() {
            return typeof this.products?.total === "number";
        },
        // #111877: keep the header title in sync after client-side category
        // switches (mirrors the desktop list's categoryTitle). Falls back to the
        // server-rendered title before the tree loads or in search mode.
        categoryTitle() {
            return findCategoryName(this.categories, this.currentCategoryId, this.title);
        },

        foundText() {
            return (this.catalogTranslations.amount_products_found ?? ":amount products found").replace(
                ":amount",
                this.products?.total ?? 0
            );
        },

        // search results only: description snippet per product whenever Description was searched and it matches
        cardSnippets() {
            const context = window.bo?.searchContext;
            if (!this.isSearching || !context?.fields?.includes("description")) return {};

            const words = searchWords(context.query);
            return Object.fromEntries(
                (this.products?.data ?? []).map((product) => [
                    product.id,
                    descriptionSnippet(product.description, words),
                ])
            );
        },
        totalAmount: function () {
            // var sum = 0;
            // this.products.forEach((e) => {
            //     sum += 1;
            // });
            // return sum;

            if (this.isFavourites) {
                let count = 0;
                this.changedIndex;

                if (this.products?.data) {
                    Object.values(this.products?.data).forEach((product) => {
                        if (product.favorited) {
                            count++;
                        }
                    });
                }

                return count;
            } else {
                return this.products?.total ?? 0;
            }
        },
        pagination: function () {
            const meta = Object.assign({}, this.products);
            delete meta.data;
            return meta;
        },
        productsData: function () {
            return this.products?.data ?? [];
        },
    },
    created() {},
    methods: {
        showPlaceholderImage,

        ...utils,

        // randomGenerateImage(index) {
        //     switch (index % 3) {
        //         case 0:
        //             return "https://help.rangeme.com/hc/article_attachments/360006928633/what_makes_a_good_product_image.jpg";
        //         case 1:
        //             return "https://as2.ftcdn.net/v2/jpg/03/20/95/21/1000_F_320952168_0qT7yDXIXNnYPpOwH9vzvg0ZzeJRQYdH.jpg";
        //         case 2:
        //             return "https://www.axis-y.com/cdn/shop/articles/001_33_1.jpg?v=1629680639";
        //         default:
        //             return "";
        //     }
        // },
        calculatePoint(productPrice) {
            return (
                Math.round(
                    parseFloat(this.pointConfig.tier_multiplier) * productPrice * this.pointConfig.conversion_rate * 100
                ) / 100
            );
        },
        // Laravel builds pagination links from whichever request produced the paginator, so
        // when the products came from the V2 catalog API `link.url` is the JSON endpoint and
        // navigating to it drops the user on a raw API response. Only the page number is
        // taken from the link — the URL we visit is always the page we are already on.
        pageUrlForSearch(pageNumber) {
            const url = new URL(window.location.href);
            url.searchParams.set("page", pageNumber);

            return url.toString();
        },

        getPageNumber(url) {
            const match = /[?&]page=(\d+)/.exec(url);

            if (!match) {
                return;
            }

            this.selectPage(parseInt(match[1], 10));
        },

        selectPage(pageNumber) {
            if (this.isSearching) {
                window.location.assign(this.pageUrlForSearch(pageNumber));
            } else {
                this.$emit("catalog_page_number", pageNumber);
            }
        },
        // amountOfProducts(products) {
        //     var amount = 0;
        //     products.forEach((product) => {
        //         amount++;
        //     });
        //     return amount;
        // },
        // computeTotal(products) {
        //     var total = 0;
        //     products.forEach((product) => {
        //         total += product.qty * product.price;
        //     });
        //     return total.toFixed(2);
        // },
        // addQuantity(product) {
        //     product.qty++;
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // minusQuantity(product) {
        //     if (product.qty > 1) {
        //         product.qty--;
        //     }
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // calculateTotalPrice(product) {
        //     if (product.qty > 0) {
        //         return (product.qty * product.price).toFixed(2);
        //     }
        //     return 0;
        // },
        // deleteEvent: function (product) {
        //     this.products.splice(this.products.indexOf(product), 1);
        // },
        // handleResize() {
        //     this.windowSize.width = window.innerWidth;
        //     this.windowSize.height = window.innerHeight;
        // },
        // calculatePoint(productPrice) {
        //     return parseFloat(this.pointConfig.tier_multiplier) * productPrice * this.pointConfig.conversion_rate;
        // },
        // isCurrentUrl(url) {
        //     let currentUrl = window.location.href;
        //     let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //     let textId = text.split("#")[0];
        //     return textId == url;
        // },
        // hasParent(items) {
        //     // console.log(items);
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //         let textId = text.split("#")[0];
        //         let url = "category/" + e.id;
        //         // console.log(textId);
        //         // console.log(e.id);
        //         // console.log(e.id == textId);
        //         if (e.id == textId) {
        //             count += 1;
        //         }
        //     });
        //     if (count > 0) {
        //         return true;
        //     }
        // },
        // hasNestedParent(grandpa, parent, items) {
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //         let textId = text.split("#")[0];
        //         let url = "category/" + e.id;
        //         // console.log(e.id+'->'+e.parent_id+'->'+grandpa);
        //         if (e.id == textId) {
        //             count += 1;
        //         }
        //     });
        //     if (count > 0) {
        //         // let grandpaId = '#cate-'+grandpa;
        //         // // console.log(grandpaId);
        //         // $("#cate-7").css("display", "block");
        //         return true;
        //     }
        // },
        // hasGrandson(items) {
        //     // console.log(items);
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         e.children.forEach((ex) => {
        //             let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //             let textId = text.split("#")[0];
        //             let url = "category/" + ex.id;
        //             if (e.id == textId) {
        //                 count += 1;
        //             }
        //         });
        //     });
        //     if (count > 0) {
        //         return true;
        //     }
        // },

        activateProductMatrixPopup(event, product) {
            if (event.target.classList.contains("variation-selection")) {
                event.preventDefault();
                this.getProduct(product.id, window.bo.productsUrl, {}, (product) => {
                    this.matrixProduct = product;
                    this.activeProductMatrixPopup = true;
                    if (success) success(this.products);
                });
            }
        },
        getMatrixProductStockInStatus(product) {
            return Object.values(this.user_warehouse_inventories).some((warehouseInventory) => {
                if (warehouseInventory.product_parent_id == product.id && warehouseInventory.balance > 0) {
                    return true;
                }
                return false;
            });
        },
        getMatrixStockClass(product) {
            if (this.getMatrixProductStockInStatus(product)) {
                return "success";
            }
            return "danger";
        },
        checkIsReturnMode() {
            return window.location.href.includes("/return/");
        },
        favoriteProduct(product, index, id) {
            // trigger computed
            this.changedIndex++;

            this.postData(
                window.bo.favoriteProductUrl,
                { product_id: product.id },
                (response) => {
                    let message =
                        response?.data ??
                        `<span style="color: #007AFF; font-weight: 600;">1</span> item(s) were updated.`;

                    this.$emit("show_snackbar", message, false);
                },
                (failure) => {
                    this.productsData[index]["favorited"] = !this.productsData[index]["favorited"];

                    if (failure?.response?.data?.errors?.code == "user_not_login") {
                        this.$emit("show_login", true);
                    } else {
                        this.$emit(
                            "show_snackbar",
                            "<span style='color:#FF0000';>" + failure?.response?.data?.message + "</span>",
                            true
                        );
                    }
                },
                false
            );

            this.$forceUpdate();
        },
        quickAddProduct(product) {
            if (product.type == "bundle") {
                window.location.href = product.product_details_url;
            } else {
                this.$emit("active_quick_add_popup", product);
            }
        },
        goBack() {
            window.history.back();
        },

        productDetails(product) {
            if (product.type == "bundle") return [];

            return productDetailParts(product.type == "variable" ? this.selectProduct(product) : null, {
                units: {
                    kg: window.bo.generalTranslations.kg,
                    m: window.bo.generalTranslations.m,
                    m3: window.bo.generalTranslations.m3,
                },
                format: (value) => this.toFixedNumber(value),
            });
        },
        // Price block (bo-price-display) for a catalog product: discounted price, tax tag and points on top,
        // original price and discount levels below. A bundle parent always shows the effective percentage.
        getCatalogPriceDisplay(product) {
            const display = buildCatalogPriceDisplay(product, {
                taxExempted: this.taxExempted,
                taxIncluded: this.taxIncluded,
                displayIncludingTax: this.displayPricesDuringCartAndCheckoutIncludingTax,
                hideLineItemTax: this.hideLineItemTax,
                currencySymbol: this.currencySymbol,
                fromLabel: this.catalogTranslations.from,
            });

            return {
                ...display,
                point: this.calculatePoint(display.price),
                showPoint: this.pointConfig != false,
            };
        },
        selectProduct(product) {
            let selectedProduct = null;

            if (!this.isEmpty(product?.default_variation) && !product?.default_variation?.hide) {
                selectedProduct = product?.default_variation;
            } else if (!this.isEmpty(product?.base_variation) && !product?.base_variation?.hide) {
                selectedProduct = product?.base_variation;
            } else if (!this.isEmpty(product?.variations) && !this.isEmpty(product?.base_variation?.id)) {
                selectedProduct = product?.variations.find((v) => v.id !== product?.base_variation?.id && !v.hide);
            } else if (!this.isEmpty(product?.variations)) {
                selectedProduct = product?.variations.find((v) => !v.hide) || product?.variations[0] || null;
            }

            if (this.isEmpty(selectedProduct) && !this.isEmpty(product?.variations)) {
                selectedProduct = product?.variations.find((v) => !v.hide) || product?.variations[0] || null;
            }

            return selectedProduct;
        },
    },
};
</script>
